import { AA_ENABLED } from '../config/env';

const Color = Object.freeze({
  background: 'white',
  blurred: '#F5FCFF88',
  primary: AA_ENABLED ? '#0078D2' : '#31a8dc',
  accent: '#ffffff',
  active: '#2e639c',
  required: '#FA2F4B',
  corporate: '#82c528',
  disabled: '#b7b9bb',
  disabledText: '#707070',
  gray: '#64696d',
  lightgray: '#F4F4F4',
  orange: '#f4592b',
  green: '#83c233',
  red: '#f4592b',
  black: '#000000',
  shadow: '#00000033',
  text: {
    high: 'rgba(0,0,0,0.87)', //High emphasis
    medium: 'rgba(0,0,0,0.60)', //Medium emphasis
    low: 'rgba(0,0,0,0.38)', //Disable text
    extraLow: 'rgba(0,0,0,0.1)',
    gray: '#999999',
  },
  grayText: '#64696d',
  grayText2: '#999',
  darkGray: '#707070',
  grayBorderColor: '#a9aaab',
  transparent: 'transparent',
  aaColor: '#333333',
  pointsEligibleColor: '#ebf6ea',
  pointsUncertainColor: '#f9e9e7',
  primaryEasyCard: '#48BEFF',
  secondaryEasyCard: '#F9F9F9',
  addReview: {
    primaryColor: '#00a0f9',
    subtitle: '#5e6263',
    background: '#f0f0f0',
    remainingChars: '#747272',
    textAreaBorder: '#ccc',
    disabledRange: '#c9c9c9',
    ruleText: '#676c70',
  },
  tezNewBlue: '#336699',
  toggleInactiveTrackColor: '#D1D5DB',
  toggleActiveTrackColor: '#80A9CC',
  formDividerColor: '#a0a0a0',
  none: 'none',
});

export default Color;
